import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { StatusBadgeList } from "../components/common/StatusBadgeList";
import { ProvisionalBadge } from "../components/common/ProvisionalBadge";
import { PublisherLink } from "../components/publisher/PublisherLink";
import { formatIsbn } from "../utils/isbn";
import { useVariantTitlesColumn } from "./useVariantTitlesColumn";
import { AgendaBadges } from "../components/agenda/AgendaBadges";
import { MonographUnitLine } from "../components/agenda/MonographUnitLine";
import { NameCell } from "../components/common/NameCell";
export var useTitlesIsbnTable = function (showIsbn) {
    if (showIsbn === void 0) { showIsbn = false; }
    var formatMessage = useIntl().formatMessage;
    var variantTitlesColumn = useVariantTitlesColumn();
    var columns = useMemo(function () {
        var base = [
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.title" }),
                key: "mainTitle",
                sortKey: "name",
                alwaysVisible: true,
                cellRenderer: function (item) { return (React.createElement(NameCell, null,
                    item.mainTitle,
                    item.provisional && React.createElement(ProvisionalBadge, null),
                    React.createElement(AgendaBadges, { agenda: item.agenda, globalType: item.globalType, link: item.specialIssueLink, linkSide: item.periodicalIssueId ? "issue" : "monograph", listedIn: "MONOGRAPHS" }),
                    React.createElement(MonographUnitLine, { row: item }))); },
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.partNumber",
                }),
                key: "partNumber",
                sortKey: "partNumber",
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.partName",
                }),
                key: "partName",
                sortKey: "partName",
            },
            variantTitlesColumn,
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.author",
                }),
                key: "firstContributor",
                sortKey: "author",
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.publisher",
                }),
                key: "publisher",
                sortKey: "publisher",
                cellRenderer: function (item) { return (React.createElement(PublisherLink, { name: item.publisher, publisherId: item.publisherId, tooltipId: "titles-publisher-".concat(item.id) })); },
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.year",
                }),
                key: "publicationYear",
                sortKey: "year",
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.edition",
                }),
                key: "editionStatement",
                sortKey: "edition",
                defaultHidden: true,
            },
            {
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.binding",
                }),
                key: "bindingText",
                sortKey: "binding",
                defaultHidden: true,
            },
        ];
        base.push({
            name: formatMessage({
                id: "ui-br-legaldeposits.titles.table.status",
            }),
            key: "depositStatuses",
            cellRenderer: function (item) {
                var _a;
                return (React.createElement(StatusBadgeList, { statusesPerRecord: (_a = item.depositStatusesPerRecord) !== null && _a !== void 0 ? _a : [] }));
            },
        });
        if (showIsbn) {
            base.push({
                name: formatMessage({
                    id: "ui-br-legaldeposits.titles.table.isbn",
                }),
                key: "isbn",
                sortKey: "isbn",
                cellRenderer: function (item) { return formatIsbn(item.isbn); },
            });
        }
        return base;
    }, [formatMessage, showIsbn, variantTitlesColumn]);
    return { columns: columns };
};
